import Vue from 'vue'
import VueRouter from 'vue-router'
import LoginView from '../views/common/login'
import Layout from "@/layout/index.vue";

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'login',
    component: LoginView
  },
  {
    path: '/watchAllVideo',
    name: 'watchAllVideo',
    component: () => import('@/views/watchAllVideo/index'),
    meta: { title: '全景', icon: 'dashboard' }
  },
  {
    path: '/',
    component: Layout,
    redirect: '/home',
    children: [
      {
        path: 'home',
        alwaysShow: true,
        component: () => import('@/views/common/home/index'),
        name: 'Home',
        meta: {title: '首页', icon: 'dashboard', affix: true}
      },
      {
        path: 'details',
        name: 'Details',
        component: () => import('@/views/common/home/details'),
        meta: {title: '详情', icon: 'dashboard'}
      }
    ]
  },
  {
    path: '/lookBack',
    name: 'LookBack',
    component: () => import('@/views/lookBack/index'),
    meta: { title: '回放', icon: 'dashboard' }
  },
  {
    path: '/fullScreen',
    name: 'FullScreen',
    component: () => import('@/views/fullScreen/index'),
    meta: { title: '全屏', icon: 'dashboard' }
  },
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  // to.meta.title && (document.title = to.meta.title);
  // document.title = '蛮筷云店'
  // 动态设置页面标题
  if (to.meta && to.meta.title) {
    // 如果路由有设置meta.title，则显示路由的title + ' - 蛮筷云店'
    document.title = `${to.meta.title} - 蛮筷云店`;
  } else {
    // 如果没有设置meta.title，则设置默认标题
    document.title = '蛮筷云店';
  }
  next();
});


export default router
